import Utils from 'common/utils'

const DEFAULT_NETWORK_TIMEOUT = 30000;

class Network {

    static post(url, headers, body, noCors, allowCookiesInCors, timeout) {

        // Create fetch argument
        let fetchArgs = {
            method: "POST"
        }

        // Check for no-cors mode
        if (false === Utils.isNull(noCors) && noCors === true) {
            noCors = false;
            fetchArgs.mode = 'no-cors'
            console.log('using no-cors')
        }

        // Add headers if present
        if (false === Utils.isNull(headers)) {
            let apiHeaders = headers;
            if (false === apiHeaders instanceof Headers) {
                apiHeaders = new Headers(headers);
            }
            fetchArgs["headers"] = apiHeaders;
        }

        // Add body if present
        if (false === Utils.isNull(body)) {
            if (body instanceof URLSearchParams) {
                fetchArgs["body"] = body
            } else if (typeof body !== "string") {
                body = JSON.stringify(body)
                fetchArgs["body"] = body
            }
        }

        // Add default timeout
        if (Utils.isNull(timeout)) {
            timeout = DEFAULT_NETWORK_TIMEOUT;
        }

        return new Promise(function (resolve, reject) {
            if (Utils.isEmptyStr(url)) {
                reject(new Error("Url cannot be empty!"))
            }

            var interval = setTimeout(function () {
                clearTimeout(interval);
                reject({ url : url, statusCode: 504, status: 'timeout - client' });
            }, timeout);

            fetch(url, fetchArgs)
                .then((response) => {
                    clearTimeout(interval);
                    resolve(response)
                })
                .catch((error) => {
                    clearTimeout(interval);
                    reject(error);
                });
        });
    }

    static fetchWithTimeout(url, timeout) {
        // Add default timeout
        if (Utils.isNull(timeout)) {
            timeout = DEFAULT_NETWORK_TIMEOUT;
        }

        return new Promise(function (resolve, reject) {
            var interval = setTimeout(function () {
                clearTimeout(interval);
                reject({ url : url, statusCode: 504, status: 'timeout - client' });
            }, timeout);
            fetch(url).then(function (response) {
                clearTimeout(interval);
                resolve(response);
            }).catch(function (error) {
                clearTimeout(interval);
                reject(error);
            });
        });
    }

    static fetchWithTimeoutAndRetry(url, timeout, retryLimit) {
        return new Promise(async (resolve, reject) => {
            if (Utils.isNull(retryLimit) || retryLimit === 0) {
                retryLimit = 1
            }

            let currTry = 0
            let lastErr = null
            while (currTry < retryLimit) {
                try {
                    let resp = await this.fetchWithTimeout(url, timeout)
                    resolve(resp)
                    return

                } catch (err) {
                    console.log("Retrying again - ", currTry, err)
                    lastErr = err
                    currTry += 1
                }
            }

            if (Utils.isNull(lastErr)) {
                lastErr = new Error("Retries exceeded")
            }
            reject(lastErr)
        });
    }
}

export default Network



// WEBPACK FOOTER //
// ./src/common/network.js